import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardContent } from '@andes/card';
import {
  ProductComparisonTable,
  SingleProductTable,
} from '@seo-frontend-components/product-comparison-table';

import { UI_LANDING_STYLE_PREFIX } from '../../../constants/appConstants';

const namespace = `${UI_LANDING_STYLE_PREFIX}-technical-sheet-component`;
const initialRowsShowedCount = 5;

const TechnicalSheet = ({ value }) => {
  const {
    title,
    view_more_text: viewMoreText,
    view_less_text: viewLessText,
    key_details: keyDetails,
    product_details: productDetails,
  } = value;

  if (!productDetails || productDetails.length === 0) {
    return null;
  }

  const isSingleProduct = productDetails.length === 1;
  const dataTestId = isSingleProduct
    ? 'single-product-table'
    : 'product-comparison-table';
  const productDetailsToRender = isSingleProduct
    ? productDetails[0]
    : productDetails;
  const TableComponent = isSingleProduct
    ? SingleProductTable
    : ProductComparisonTable;

  return (
    <div className={namespace}>
      <Card>
        <CardContent>
          <div data-testid={dataTestId}>
            <TableComponent
              initialRowsShowedCount={initialRowsShowedCount}
              title={title}
              viewMoreText={viewMoreText}
              viewLessText={viewLessText}
              keyDetails={keyDetails}
              productDetails={productDetailsToRender}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

TechnicalSheet.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    view_more_text: PropTypes.string.isRequired,
    view_less_text: PropTypes.string.isRequired,
    key_details: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        order: PropTypes.number.isRequired,
      }),
    ),
    product_details: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        price: PropTypes.string.isRequired,
        attributes: PropTypes.arrayOf(
          PropTypes.shape({
            key: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }),
        ).isRequired,
      }),
    ),
  }).isRequired,
};

export default TechnicalSheet;
